<div class="row row-no-side-margin">
    <div *ngIf="progressBar?.name" class="col progress-name" [title]="progressBar?.name">{{progressBar?.name}} </div>
    <div class="col progress bar-progress" [ngbTooltip]="progressBar?.tooltipText">
        <div [ngStyle]="{
    'background-color' : progressBar?.color}" [style.width.%]="progressBar?.percentage" role="progressbar"
            aria-valuenow="progressBar?.percentage" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
    <div class="col progress-percentage" [ngStyle]="{'color' : progressBar?.color}">
        {{progressBar?.displayPercentage}}%</div>
</div>